import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, faqLD, SITE_URL } from "@/content/seo";

const TITLE = "Cruzeiro de Aniversário em Vilamoura · Iate Privado · Morningstar";
const DESC = "Celebre o seu aniversário em Vilamoura no Morningstar — iate privado até 18 pessoas, bolo opcional, DJ, saxofonista e decoração personalizada. Horário ao pôr-do-sol disponível.";
const PATH = "/pt/cruzeiro-aniversario-vilamoura";
const URL = `${SITE_URL}${PATH}`;

export const Route = createFileRoute("/pt/cruzeiro-aniversario-vilamoura")({
  component: () => (
    <SitePage
      lang="pt"
      heroOverride={{
        eyebrow: "Aniversário · Vilamoura · Algarve",
        title: "Cruzeiro de aniversário em Vilamoura a bordo do ",
        titleAccent: "Morningstar.",
        sub: "O seu iate privado, a sua playlist, os seus convidados — adicione bolo, saxofonista, DJ e pôr-do-sol. Até 18 pessoas, totalmente tripulado.",
        ctaPrimary: "Ver cruzeiros",
        ctaSecondary: "Planear o meu aniversário",
      }}
    />
  ),
  head: () =>
    buildHead({
      lang: "pt",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords: "aniversário barco vilamoura, festa aniversário iate algarve, cruzeiro aniversário vilamoura, festa barco vilamoura",
      altPath: { en: "/birthday-cruise-vilamoura", pt: PATH },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Vilamoura Birthday Cruise",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Início", path: "/pt" },
              { name: "Aniversário Vilamoura", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(faqLD("pt")) },
      ],
    }),
});
